// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WalletTransactions_wallet-transactions__sqSkZ {
  display: flex;
  flex-direction: column;
  gap: 5.8rem;
}

.WalletTransactions_wallet-transactions__list-item__F8ORA {
  border-radius: 1rem;
  border: 1px solid var(--black-ten-opacity);
  padding: 3rem 4rem;
}

.WalletTransactions_wallet-transactions__date-wrapper__oIvrY {
  margin-bottom: 4rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/Profile/Wallet/WalletTransactions/WalletTransactions.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".wallet-transactions {\n  display: flex;\n  flex-direction: column;\n  gap: 5.8rem;\n}\n\n.wallet-transactions__list-item {\n  border-radius: 1rem;\n  border: 1px solid var(--black-ten-opacity);\n  padding: 3rem 4rem;\n}\n\n.wallet-transactions__date-wrapper {\n  margin-bottom: 4rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wallet-transactions": `WalletTransactions_wallet-transactions__sqSkZ`,
	"wallet-transactions__list-item": `WalletTransactions_wallet-transactions__list-item__F8ORA`,
	"wallet-transactions__date-wrapper": `WalletTransactions_wallet-transactions__date-wrapper__oIvrY`
};
export default ___CSS_LOADER_EXPORT___;
